import { Logger as LoggerUtils } from '@asgard/ui-common';

export const Logger = LoggerUtils;

/**
 * @deprecated Use `Logger.error()` from `ui-common` instead
 */
export const logError = Logger.error;
